import axios from 'axios';
import { z } from 'zod';

const storeSelectionResponseSchema = z.array(z.string());

/** @see AppleRetail.Web.ApiControllers.ShopStoreSelectionApiController.GetStoreSelection */
export async function getStoreSelections(signal?: AbortSignal) {
	const { data } = await axios.get<unknown>('/api/shop/store-selection', { signal });
	return storeSelectionResponseSchema.parse(data);
}

/**
 * @see AppleRetail.Web.ApiControllers.ShopStoreSelectionApiController.AddStoreToSelection
 * @see AppleRetail.Web.ApiControllers.ShopStoreSelectionApiController.RemoveStoreFromSelection
 */
export async function setStoreSelection(storeCode: string, selected: boolean) {
	const { data } = selected
		? await axios.post<unknown>(`/api/shop/store-selection/store/${storeCode}`, {})
		: await axios.delete<unknown>(`/api/shop/store-selection/store/${storeCode}`);
	return storeSelectionResponseSchema.parse(data);
}

/**
 * @see AppleRetail.Web.ApiControllers.ShopStoreSelectionApiController.RemoveStoresFromSelection
 */
export async function clearStoreSelections() {
	const { data } = await axios.delete<unknown>('/api/shop/store-selection/stores', {
		// This endpoint expects a body, so we pass a partial request object
		data: {
			countryCode: null,
		},
	});
	return storeSelectionResponseSchema.parse(data);
}
